import { render, staticRenderFns } from "./Supervise.vue?vue&type=template&id=3d954bd8&scoped=true&"
import script from "./Supervise.vue?vue&type=script&lang=js&"
export * from "./Supervise.vue?vue&type=script&lang=js&"
import style0 from "./Supervise.vue?vue&type=style&index=0&id=3d954bd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d954bd8",
  null
  
)

export default component.exports